var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 4.5,
    fill: "white",
    stroke: "#E0E0E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.41 15.41L23.58 10.58C23.21 10.21 22.7 10 22.17 10H15C13.9 10 13.01 10.9 13.01 12L13 28C13 29.1 13.89 30 14.99 30H27C28.1 30 29 29.1 29 28V16.83C29 16.3 28.79 15.79 28.41 15.41ZM23.8 23H22V26C22 26.55 21.55 27 21 27C20.45 27 20 26.55 20 26V23H18.21C17.76 23 17.54 22.46 17.86 22.15L20.66 19.36C20.86 19.17 21.17 19.17 21.37 19.36L24.16 22.15C24.46 22.46 24.24 23 23.8 23ZM23 17C22.45 17 22 16.55 22 16V11.5L27.5 17H23Z",
    fill: "#2F80ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFile);
export default __webpack_public_path__ + "static/media/upload-file.87dee1917b092faefe94ba81bb3c84fa.svg";
export { ForwardRef as ReactComponent };